import React from "react";
import { Type, Anchor } from "@ebscois/react-component-library";
import { Link } from "react-router-dom";

const buildViewInContextString = (items, onRequestClose) => {
  if (!items || !items.length) {
    return undefined;
  }
  return items.map((item, idx) => (
    <>
      <Anchor
        data-testid="view-in-context-string-anchor"
        linkComponent={Link}
        fontSize="sm"
        href={`${item?.slug}#${item?.an?.toUpperCase()}`}
        onClick={() => {
          onRequestClose();
          window.location.href = `${item.slug}#${item.an?.toUpperCase()}`;
        }}
      >
        {item?.title}
      </Anchor>
      {idx === items.length - 1 ? "" : "; "}
    </>
  ));
};

const ViewInContextString = ({ associatedTopics, onRequestClose }) => {
  const builtViewInContextString = buildViewInContextString(
    associatedTopics,
    onRequestClose
  );
  return (
    <>
      {builtViewInContextString && (
        <Type
          element="p"
          paddingTop="sm"
          data-testid="view-in-context-string"
          fontSize="sm"
        >
          {/* The string "View In Context" is formatted as it is because ther same
          string in search comes from the Experience and it's delivered as ALLCAPS*/}
          <Type element="span" fontSize="sm" fontWeight="semibold">
            View In Context:
          </Type>{" "}
          {builtViewInContextString}
        </Type>
      )}
    </>
  );
};

export default ViewInContextString;
